import React from "react";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { Image } from "BaseComponents/Image";
export const Employee = ({ Name, Telephone, Email, Image: src, Text, Title: TitleText }) => {
	let hasText = Text.length > 0;
	return (
		<EmployeeBlockContainer>
			<EmployeeWrapper>
				<Left hasText={hasText}>
					<Image borderRadius="50%" size="200px" bgImage={src} />
					<NameWrapper>
						<H3 lineHeight="24px">{Name}</H3>
						{Title && <Title>{TitleText}</Title>}
					</NameWrapper>
				</Left>
				<Right hasText={hasText}>
					{hasText && (
						<TextWrapper>
							<p>{Text}</p>
						</TextWrapper>
					)}
					<ContactWrapper>
						{Telephone && <a href={`tel:${Telephone}`}>{Telephone}</a>}
						{Email && <a href={`mailto:${Email}`}>{Email}</a>}
					</ContactWrapper>
				</Right>
			</EmployeeWrapper>
		</EmployeeBlockContainer>
	);
};
export const EmployeeBlockContainer = styled.div`
	${media.greaterThan(breakpoints.mobile)`
	margin-left: 15px;

		max-width: 48%; `}
	${media.greaterThan(breakpoints.ipad)`
		max-width: 31.9%;`}
	${media.greaterThan(breakpoints.desktop)`
		max-width: 32%;`}
	
	flex-basis: calc(47% - 20px);
	width: auto;
	min-width: 220px;
	flex-grow: 1;
`;

export const Left = styled.div`
	background: ${({ theme }) => theme.colors.white};
	display: flex;
	border-radius: ${({ hasText }) => (!hasText ? "5px" : "")};
	span {
		word-break: break-all;
		font-size: 14px;
	}
	a span {
		line-height: 16px;
	}
	flex-direction: column;
	align-items: center;

	${media.lessThan(breakpoints.mobile)`

		border-radius: ${({ hasText }) => (hasText ? "5px 5px 0 0" : "5px")};
		min-width: 0;
		flex-wrap: wrap;
		min-height: 137px;
		align-items: center;

		${Image} {
			margin: 10px;
		}
	`}
`;
export const Right = styled.div`
	width: 100%;
	border-radius: 0 0px 5px 5px;

	${media.lessThan(breakpoints.mobile)`
	padding: 10px;

	`};
`;
export const EmployeeWrapper = styled.div`
	${media.lessThan(breakpoints.mobile)`
		padding: 10px;
		height: auto;
		justify-content: space-between;

	`}
	height: calc(100% - 20px);
	background: white;
	display: flex;
	border-radius: 5px;
	margin: 20px 0 0 0;
	padding: 25px;
	min-height: 120px;

	width: 100%;
	flex-direction: column;
	max-height: unset;
	position: unset;
`;
export const H3 = styled.h3`
	font-size: 18px;
	line-height: 24px;
	margin-bottom: 0;
	margin: 0;
`;
export const Title = styled.span`
	font-size: 14px;
	line-height: 16px;
	color: #333333;
`;
export const NameWrapper = styled.div`
	text-align: center;
	a {
		justify-content: center;
	}

	display: flex;
	flex-direction: column;
	${media.lessThan(breakpoints.mobile)`
	margin: 0px 10px 0px 10px;
`}
	margin: 10px 10px 10px 10px;
	a[class^="EmailLink"],
	a[class*="EmailLink"] {
		span {
			line-height: 14px;
		}
	}
	a {
		margin: 5px 0;

		span {
			line-height: 15px;
		}
	}

	a,
	i,
	i::before {
		margin-left: 0;
	}
	svg {
		min-width: 16px;

		margin-right: 8px;
	}
`;
const ContactWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 20px 0 0 0;

	a {
		border-bottom: 2px solid transparent;
		transition: 0.2s ease;
		&:hover {
			border-color: black;
			transition: 0.2s ease;
		}
	}

	word-break: break-word;
	${media.lessThan(breakpoints.mobile)`
	padding: 10px 0 0 0;
`}
`;

export const TextWrapper = styled.div`
	background-color: white;
	width: 50%;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	p {
		font-size: 14px;
		margin: 0;

		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.57;
	}
	${media.lessThan(breakpoints.mobile)`
	max-width: unset;
	min-width: 0;
	width: unset;
`}
`;
